import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

export interface IProjectType {
    // tslint:disable
    getAll(options: ODataOptions, jwt: string): Promise<any>;
    get(id: number, jwt: string): Promise<any>;
    // tslint:enable
}

export default class ProjectType extends BaseApi implements IProjectType {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.get = this.get.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/projectTypes/${options.toString()}`, jwt);
    }

    public get(id: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/not-gonna-work`, jwt);
    }
}



// WEBPACK FOOTER //
// ./src/api/ProjectType.ts